import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #26: A new page for a new React Indie Bundle",
  "description": "",
  "published": "2016-11-14T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-26-new-page-react-indie-bundle/swizec/7211"],
  "categories": "Front End, Livecoding, react, Technical",
  "hero": "./img/7ztmthi.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding ?. Always under 500 words and with pictures. You can follow my channel `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New content almost `}<strong parentName="em">{`every Sunday at 2pm Pacific`}</strong>{`. There’s live chat, come say hai ?`}</em></p>
    <p>{`In an unprecedented move, this weekend I livecoded twice. There was much to do.`}</p>
    <p>{`No livecoding for the third session. Girlfriends and birds need sleep, and my office has no door. Silly, I know. What kind of office doesn't have a door? ¯`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <p>{`The first session revolved around two things:`}</p>
    <ul>
      <li parentName="ul">{`Wait, what's in the Bundle again?`}</li>
      <li parentName="ul">{`I can't design, but maybe I can find a good thing on Themeforest.`}</li>
    </ul>
    <p>{`The second session was all about:`}</p>
    <ul>
      <li parentName="ul">{`Aaaaaah My old React framework for landing pages doesn't work with this theme I bought and this theme is being confusing and I don't know how turn bits of it into React components aaaaaah!`}</li>
    </ul>
    <p><img parentName="p" {...{
        "src": "/5dc4c29535782eb407b50bf2a185d0ff/FpcN8fN.gif",
        "alt": null
      }}></img></p>
    <p>{`I'm not going to spell out the first section here just yet. The bundle is going to be amazing, and if you want to see what it's `}<em parentName="p">{`probably`}</em>{` going to contain, watch the video. Hopefully I get final confirmation from the other authors soon ?`}</p>
    <p>{`There are going to be 3 tiers again, just like last year: Basic, Epic, Majestic. I wanted to do two tiers, but Stephen is a machine, and we have too much amazing stuff to offer. Pricing just didn't make sense with two tiers. Alas.`}</p>
    <p>{`Basic might be a bit pricey right now. Is $89 too much for the basic offering if full value is $149? ?`}</p>
    <hr></hr>
    <p>{`This year's page is built around the `}<em parentName="p">{`"Why we ❤️ React"`}</em>{` theme. Last year, it was all about "Take the leap, learn React, it's cool, we promise" and about making more money and building shit faster. That worked great in 2015, but I think that in 2016, everyone already knows a lot of this.`}</p>
    <p>{`So I wanted to make it more community focused. Promote the React love, let others talk about why it's great, then offer a helping hand in learning. Thoughts?`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/351654e457f99da3c87495861b7e0b1b/cf4cc/7ztmthi.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "43.497757847533634%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'173\\'%20viewBox=\\'0%200%20400%20173\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M28%2094l1%207h13V88l-7-1h-7v7m181%200l1%207h13V88l-7-1h-7v7\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/351654e457f99da3c87495861b7e0b1b/ca0a1/7ztmthi.webp 223w", "/static/351654e457f99da3c87495861b7e0b1b/75680/7ztmthi.webp 445w", "/static/351654e457f99da3c87495861b7e0b1b/8d1ba/7ztmthi.webp 890w", "/static/351654e457f99da3c87495861b7e0b1b/09917/7ztmthi.webp 1079w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/351654e457f99da3c87495861b7e0b1b/e92b6/7ztmthi.png 223w", "/static/351654e457f99da3c87495861b7e0b1b/e66bf/7ztmthi.png 445w", "/static/351654e457f99da3c87495861b7e0b1b/4ef49/7ztmthi.png 890w", "/static/351654e457f99da3c87495861b7e0b1b/cf4cc/7ztmthi.png 1079w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/351654e457f99da3c87495861b7e0b1b/4ef49/7ztmthi.png",
              "alt": "7ztmthi",
              "title": "7ztmthi",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`I'm hoping to convince the other authors - Stephen, Andrzej, Juho, Azat - to make a 10- or 20-second selfie video saying why they love React. That would work marvelously on the page, I think.`}</p>
    <p>{`Last time someone asked me for a video testimonial, it took 5 weeks to muster the courage. We'll see how that works. Cyber Monday is around the corner :D`}</p>
    <p>{`Hmmm ... technical stuff ?`}</p>
    <p>{`Honestly, there isn't that much technical stuff that goes into slapping together a landing page. It follows this pattern:`}</p>
    <ul>
      <li parentName="ul">{`Look at bought theme`}</li>
      <li parentName="ul">{`Oooh, I like this widget!`}</li>
      <li parentName="ul">{`Inspect source`}</li>
      <li parentName="ul">{`Copy-pasta source as React component`}</li>
      <li parentName="ul">{`Repeat until done`}</li>
    </ul>
    <p>{`Labour intensive at first, but gets quicker and quicker. For example, I can now make dark sections with top or bottom decoration like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`<DarkSection hasTop="rightSlope"
             hasBottom="zigZag">
    <Content.WhyPain />
</DarkSection>
`}</code></pre>
    <p>{`Neat.`}</p>
    <p>{`You can see the `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/new-react-bundle-page"
      }}>{`source on github`}</a>{`.`}</p>
    <p>{`Thanks to the audience for helping with the pricing and picking a theme. You guys rock :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      